import Lottie from "lottie-react";

import Logo from "@assets/images/main-logo-green.svg";
import loader from "@assets/animations/loader.json";

import useSystemStore from "@store/useSystemStore";
import { useMemo } from "react";

export function AppLoader() {
  const { isDarkMode } = useSystemStore();

  function darkenLottie(json: any) {
    const targetColor = [0.835, 0.859, 0.847, 1];
    const darkRGB = [156 / 255, 161 / 255, 175 / 255, 1];

    const isSameColor = (a: number[], b: number[]) =>
      a.length === b.length && a.every((v, i) => Math.abs(v - b[i]) < 0.01);

    json.assets?.forEach((asset: any) => {
      asset.layers?.forEach((layer: any) => {
        layer.shapes?.forEach((shape: any) => {
          shape.it?.forEach((item: any) => {
            if ((item.ty === "st" || item.ty === "fl") && Array.isArray(item.c?.k)) {
              if (isSameColor(item.c.k, targetColor)) {
                item.c.k = darkRGB;
              }
            }
          });
        });
      });
    });
  }

  const themedLoader = useMemo(() => {
    const copy = JSON.parse(JSON.stringify(loader));
    if (isDarkMode) {
      darkenLottie(copy);
    }
    return copy;
  }, [isDarkMode]);

  return (
    <div className="mt-[180px] flex flex-col items-center">
      <Logo className="mb-4 h-auto" />
      <Lottie animationData={themedLoader} loop autoplay style={{ width: "200px" }} />
    </div>
  );
}
